import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/content';
const FIRST_DELAY = 9000;
const VISIBLE_MS = 5500;
const GAP_MS = 14000;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let showTimer: number;
    let hideTimer: number;
    const cycle = (delay: number) => {
      showTimer = window.setTimeout(() => {
        setVisible(true);
        hideTimer = window.setTimeout(() => {
          setVisible(false);
          setIndex(i => (i + 1) % purchaseNotifications.length);
          cycle(GAP_MS);
        }, VISIBLE_MS);
      }, delay);
    };
    cycle(FIRST_DELAY);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
    };
  }, [dismissed]);
  const person = purchaseNotifications[index];
  return <AnimatePresence data-id="element-40" data-mp="163wcgqrtry1s">
      {visible && !dismissed ? <motion.div initial={{
      opacity: 0,
      y: 16,
      scale: 0.97
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.97
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed left-3 right-3 top-3 z-[60] mx-auto max-w-sm rounded-xl border border-teal/40 bg-ink-900/95 p-3 shadow-2xl backdrop-blur sm:left-4 sm:right-auto sm:top-auto sm:bottom-24" role="status" data-id="element-41" data-mp="115uxoi1fmkw4">
          <div className="flex items-start gap-3" data-id="element-42" data-mp="x5u7y18vun9r">
            <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-teal-bright" aria-hidden="true" data-id="element-43" data-mp="x6m4beab0p13" />
            <div className="min-w-0 flex-1" data-id="element-44" data-mp="28jyahvtjdjqf">
              <p className="text-[13px] font-bold leading-snug text-white" data-id="element-45" data-mp="28iwpozmpxivi">
                {person.name} from {person.country}
              </p>
              <p className="mt-0.5 text-[12px] leading-snug text-white/60" data-id="element-46" data-mp="2aothw6inzjez">
                just got the Master Welding System™ digital pack
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="-mr-1 -mt-1 rounded-md p-1 text-white/40 transition-colors duration-150 ease-out hover:text-white" data-id="element-47" data-mp="2fph8ws6w8097">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-48" data-mp="1rzwm1y7mciun" />
            </button>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}